import { env } from '../../constants/env';
import { useFlux } from '../use-flux';

export function useAPI(signatureRequestKey: string) {
  function getEndpoint(endpoint: string) {
    const { isFlux } = useFlux();

    const prefix = {
      notarial: '/notarial/widget/signatures',
      flux: `${env.FLUX_API_URL}/fluxes`,
    };
    const suffix = endpoint ? `/${endpoint}` : '';
    const url = `${prefix[isFlux ? 'flux' : 'notarial']}/`;

    return `${url}${signatureRequestKey}${suffix}`;
  }

  return { getEndpoint };
}
